<template>

  <div :class="{'nav-open': $sidebar.showSidebar}">
    <grid></grid>
    <gridOnline></gridOnline>
    <RDPModal></RDPModal>
    <PhotoModal></PhotoModal>

    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <transition name="fade"
                mode="out-in">
      <keep-alive>          
      <router-view>
        
      </router-view>
    </keep-alive>
    </transition>
  </div>
</template>

<script>
// import { USER_REQUEST } from './store/actions/user'
import axios from 'axios'
import { AUTH_LOGOUT } from './store/actions/auth'
// Loading some plugin css asynchronously
import('sweetalert2/dist/sweetalert2.css')
import('vue-notifyjs/themes/default.css')

import grid from './components/Dashboard/Views/Charts/Grid'
import gridOnline from './components/Dashboard/Views/ChartsOnline/GridOnline'
import RDPModal from 'src/components/Dashboard/Views/Charts/rdp_modal'
import PhotoModal from 'src/components/Dashboard/Views/ChartsOnline/photo_modal'


export default {
  name: 'app',
  created: function () {
    //console.log('APP...')
    const self = this;

    let isAlreadyFetchingAccessToken = false
    let subscribers = []

    function onAccessTokenFetched(access_token) {
      subscribers = subscribers.filter(callback => callback(access_token))
    }

    function addSubscriber(callback) {
      subscribers.push(callback)
    }

    axios.interceptors.response.use(function (response) {
    //console.log('01 - axios response ok...')
    return response;
    }, function (error) {
        //console.log('02 - axios response error ')

        const { config, response: { status } } = error
        const originalRequest = config

        //console.log('originalRequest: ', originalRequest)

        if (status === 401) {
          if (!isAlreadyFetchingAccessToken) {
            let hash = localStorage.getItem('hash')
            //console.log('Hash: ', hash)
            //se possuir a hash, que é o usuário e senha criptografados
            if(hash){
              isAlreadyFetchingAccessToken = true
              //console.log('03 - axios response (401) - Session Expired!...')
              const API = process.env.ROOT_API   
              const ENDPOINT = 'v1/login-mysemeq?params='
              axios({method: 'GET', url: API + ENDPOINT + hash})
              .then(resp => {
                  var token = resp.data
                  localStorage.setItem('user-token', resp.data['access_token'])
                  axios.defaults.headers.common['Authorization'] = resp.data['access_token']
                  var access_token = resp.data['access_token']
                  //console.log('04 new token ok...', access_token)

                  isAlreadyFetchingAccessToken = false
                  onAccessTokenFetched(access_token)

                  //REFRESH GERAL
                  //location.reload()

              })
              .catch(err => {
                //alert('Session Expired!');
                self.$store.dispatch(AUTH_LOGOUT).then(() => self.$router.push('/login'))
              })

            } else{
              //console.log('HASH VAZIO...')
              //console.log('VAI PRO LOGIN...')
              self.$store.dispatch(AUTH_LOGOUT).then(() => self.$router.push('/login'))
            }
          }
           // aqui criamos um promise chamado retryOriginalRequest
          const retryOriginalRequest = new Promise((resolve) => {
            //console.log('05 axios retryOriginalRequest (fim)!!')
            //console.log('REFRESH TOKEN')
            // então adicionamos um callback (método a se executado)
            addSubscriber(access_token => {
              // informacos as configurações da requisição original, mas fornecemos o novo token
              originalRequest.headers.Authorization = 'Bearer ' + access_token
              // forçamos o axios a executar a requisição original
              resolve(axios(originalRequest))
            })
          })

          // retornamos a reuisição a ser executada
          return retryOriginalRequest      

        }
      return Promise.reject(error);
    });

  /*  axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        // if you ever get an unauthorized, logout the user
          //this.$store.dispatch(AUTH_LOGOUT)
        // you can also redirect to /login if needed !
        }
        throw err
      })
    })*/
  },
  components: {
    grid: grid,
    gridOnline: gridOnline,
    RDPModal: RDPModal,
    PhotoModal: PhotoModal,
  }
}

</script>
<style lang="scss">
  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;

    }
    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }
    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

.title-charts{
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #E0E0E3;
  position: relative;
  z-index: 99;
} 

.icon-help{
  color: #68B3C8;
  font-size: 12px;
  font-weight: normal;
}

.bt-help{
  background: none;
  border:0px;
}

.show-from-left-enter-active, .show-from-left-leave-active {
  transition: transform 1s, opacity 0.7s;
}
.show-from-left-enter, .show-from-left-leave-to {
  opacity: 0;
  transform: translate(20px);
}

/* Five Columns Layout */
.col-xs-5ths,
.col-sm-5ths,
.col-md-5ths,
.col-lg-5ths {
    position: relative;
    min-height: 1px;
    padding-right: 10px;
    padding-left: 10px;
    margin-bottom: 10px;
}

.col-xs-5ths {
    width: 20%;
    float: left;
}

@media (min-width: 768px) {
    .col-sm-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 992px) {
    .col-md-5ths {
        width: 20%;
        float: left;
    }
}

@media (min-width: 1200px) {
    .col-lg-5ths {
        width: 20%;
        float: left;
    }
}

@media screen and (max-width: 1200px) {
  .box-container {
    display: block;
  }
  .box-divided:first-child {
    margin-right: 0;
    /*margin-bottom: 10px;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue